__turbopack_context__.v({
  "SDefaultSvg": "Dhmwta_SDefaultSvg",
  "SFilledPath": "Dhmwta_SFilledPath",
  "isFilled": "Dhmwta_isFilled",
});
